import React from 'react';
import toast, { Toaster } from 'react-hot-toast';

import {confirmAlert} from "react-confirm-alert";
import Role from "../../inc/Role";
import {NavLink, useNavigate, useParams} from "react-router-dom";
import * as Icon from "react-bootstrap-icons";
import {Config} from '../../Config'
import Select from 'react-select'
import * as Utils from "../../inc/Utils";
import moment from "moment-timezone";
import {getKol} from "../../inc/Utils";

export default function AdsCampaignGroupItemCreate() {
    const roles = new Role();
    let userId = roles.loginUserId;

    let {encode} = useParams();
    let decode = Utils.decodeItem(encode);
    let adsCampaignGroupId = decode.adsCampaignGroupId;
    let adsCampaignGroupTitle = decode.adsCampaignGroupTitle;

    let backPath = '/adsCampaignGroupItem/' + Utils.encodeItem({id: adsCampaignGroupId, adsCampaignGroupTitle: adsCampaignGroupTitle});

    let btnTextDefault = 'บันทึกข้อมูล';
    let btnTextLoading = 'กำลังบันทึก..';
    let [isLoading, setLoading] = React.useState(false);
    let [adsNaming, setAdsNaming] = React.useState('');

    let [agency, setAgency] = React.useState('');
    let [agencyId, setAgencyId] = React.useState(null);
    let [platform, setPlatform] = React.useState('');
    let [platformId, setPlatformId] = React.useState(null);

    let [kolPage, setKolPage] = React.useState('');

    const navigate = useNavigate();

    let refName = React.useRef();

    React.useEffect(() => {
        (async function() {
            try {
                const resPlatform = await Utils.getPlatformAll();
                setPlatform(resPlatform);

                //region set new agency
                const resAgency = await Utils.getAgencySlug();
                let newAgencies = [];
                if(resAgency) {
                    let newA = resAgency.find(e => e.id === roles.agencyId).items;
                    let ownerIds = [];
                    for(let a of newA) {
                        ownerIds.push(a.ownerId);
                    }
                    for(let ag of resAgency) {
                        if(ag.items.find(e => ownerIds.includes(e.ownerId))) {
                            newAgencies.push({
                                id: ag.id,
                                slug: ag.slug,
                                name: ag.name
                            })
                        }
                    }
                }
                setAgency(newAgencies);
                setAgencyId(newAgencies.filter(e => e.id === roles.agencyId)[0]);
                //endregion


                const resAdsNaming = await Utils.getAdsNamingCampaign();

                if(resAdsNaming.length > 0) {

                    setAdsNaming(resAdsNaming);

                    let newKolPageId = [];
                    for(let rs of resAdsNaming) {
                        if(rs.inputType === Utils.ADSNAMING_TYPE_KOL_PAGE) {
                            const resKolPage = await getKol();
                            if(resKolPage) {
                                let kolPageIds = [];
                                for(let row of resKolPage) {
                                    let id = row.id;
                                    kolPageIds.push({
                                        id: id + ':KOL' + rs.id,
                                        name:  row.name
                                    });
                                }
                                newKolPageId.push({
                                    id: rs.id,
                                    data: kolPageIds
                                });
                            }
                        }
                    }
                    setKolPage(newKolPageId);
                }
            } catch (e) {
                toast.error(e.message);
            }
        })();
    }, []);

    const onCreate = async () => {

        let param = await getParams();
        let name = refName.current.value;

        if(!name) {
            toast.error("กรุณาระบุ ชื่อ Group Item");
            refName.current.focus();
        }
        else if(!agencyId) {
            toast.error("กรุณาระบุ Agency");
        }
        else if(!param.success) {
            toast.error("กรุณาเลือก Parameters ให้ครบถ้วน");
        }
        else {
            confirmAlert({
                title: 'แจ้งเตือน',
                message: 'ต้องการบันทึกข้อมูล ?',
                buttons: [
                    {
                        label: 'ตกลง',
                        onClick: () => {
                            setLoading(true);

                            let statusChecked = document.getElementsByName('statusChecked');

                            const body = {
                                sourceTypeIds: param.data,
                                name: name,
                                adsCampaignGroupId: adsCampaignGroupId,
                                agencyId: agencyId ? agencyId.id : null,
                                adsPlatformId: platformId ? platformId.id:null,
                                status: statusChecked[0].checked ? 1:0,
                                createdBy: userId,
                                createdAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss'),
                                updatedAt: moment().tz('Asia/Bangkok').format('YYYY-MM-DD HH:mm:ss')
                            };

                            fetch(Config.url.API_URL +'/api/adsCampaignGroupItem/create', {
                                method: 'POST',
                                body: JSON.stringify(body),
                                headers: {
                                    'Content-Type':'application/json',
                                    'x-access-token': roles.accessToken
                                }
                            }).then(response => {
                                setLoading(false);
                                if(response.ok) {
                                    return response.json();
                                }
                                else {
                                    return response.json().then(err => Promise.reject(err));
                                }
                            }).then(result => {
                                if(result) {
                                    toast.success("บันทึกข้อมูลเรียบร้อย");
                                    setTimeout(function () {
                                        navigate(backPath, {replace: true});
                                    }, 1500);
                                }
                            }).catch(err => {
                                toast.error(err.message);
                            })
                        }
                    },
                    {
                        label: 'ยกเลิก',
                        onClick: () => {}
                    }
                ]
            });
        }
    };

    const onChangeAgencyId = (obj) => {
        setAgencyId(obj);
    };

    async function getParams() {
        let textParams = [];
        let sourceIds = [];
        let kolIds = [];

        //STEP 1 : Find Selected
        let sourceTypeIds = [];
        let sourceTypeAllIds = [];
        let selectSourceTypeIds = document.getElementsByName('sourceTypeIds[]');
        if(selectSourceTypeIds) {
            for(let st of selectSourceTypeIds) {
                let sourceTypeId = st.value;
                if(sourceTypeId) {

                    //STEP 1.1 : Find special selector
                    if(sourceTypeId.includes(':KOL')) {
                        let sp = sourceTypeId.split(':KOL');
                        let kolId = sp[0];
                        let adsNamingId = sp[1];
                        if(kolId) {
                            kolPage.find(rs => {
                                if(parseInt(rs.id) === parseInt(adsNamingId)) {
                                    let data = rs.data.find(e => {
                                        let id = e.id;
                                        if(id.toString().includes(kolId + ':')) {
                                            return e;
                                        }
                                    });
                                    if(data) {
                                        kolIds.push({
                                            adsNamingSourceId: parseInt(kolId),
                                            adsNamingId: parseInt(adsNamingId),
                                            name: data ? data.name : null,
                                            inputType: Utils.ADSNAMING_TYPE_KOL_PAGE
                                        });
                                    }
                                }
                            });
                        }
                    }
                    else {
                        sourceTypeIds.push(sourceTypeId);
                    }
                    sourceTypeAllIds.push(sourceTypeId);
                }
            }
        }

        //STEP 2 : Get selector type
        if(sourceTypeIds.length > 0) {
            let result = await Utils.getSourceTypeForParam(sourceTypeIds);
            if(result) {
                for(let row of result) {
                    sourceIds.push({
                        adsNamingSourceId: row.id,
                        adsNamingId: row.adsNamingId,
                        name: row.name,
                        inputType: null
                    });
                }
            }
        }

        //STEP 4 : Get for params
        if(adsNaming.length > 0) {
            adsNaming.map(async (row, index) => {
                let value = '';
                let inputText = "sourceTypeText[" + row.id + "]";
                let textSourceTypeIds = document.getElementsByName(inputText);
                if(textSourceTypeIds && textSourceTypeIds[0]) {
                    value = textSourceTypeIds[0].value;
                    if(value.length > 0 || row.inputType === Utils.ADSNAMING_TYPE_SLUG_PROJECT) {
                        textParams.push({
                            adsNamingSourceId: null,
                            adsNamingId: row.id,
                            text: value,
                            inputType: row.inputType
                        });
                    }
                }
                else {
                    if(row.inputType === Utils.ADSNAMING_TYPE_KOL_PAGE) {
                        if(kolIds) {
                            let find = kolIds.find(kol => {
                                if(kol.adsNamingId === row.id) {
                                    return kol;
                                }
                            });
                            if(find && find.name) {
                                textParams.push({
                                    adsNamingSourceId: find.adsNamingSourceId,
                                    adsNamingId: row.id,
                                    text: find.name,
                                    inputType: row.inputType
                                });
                            }
                        }
                    }
                    else {
                        let find = sourceIds.find(rs => {
                            if(parseInt(rs.adsNamingId) === parseInt(row.id)) {
                                return rs;
                            }
                        });
                        if(find && find.name) {
                            textParams.push({
                                adsNamingSourceId: find.adsNamingSourceId,
                                adsNamingId: row.id,
                                text: find.name,
                                inputType: null
                            });
                        }

                        if(row.name === 'Objective') {
                            let platformName = '';
                            if(platform && platformId !== null && platformId.id) {
                                platformName = platform.filter(e => e.id === platformId.id)[0].name;
                                textParams.push({
                                    adsNamingSourceId: null,
                                    adsNamingId: null,
                                    text: platformName,
                                    inputType: null
                                });
                            }
                        }
                    }
                }
            });
        }

        return {params: null, data: textParams, success: sourceTypeAllIds.length === selectSourceTypeIds.length};
    }

    const onChangePlatformId = (platformRow) => {
        setPlatformId(platformRow);
    };

    return (
        <main>
            <div className="row table-toolbar mb-2">
                <div className="col-12 align-self-center">
                    <div className="h6 d-inline"><span className="text-success">&#8226;</span> Ads Campaign Group Item</div>
                    <span className="ms-1">/</span> <span className="text-danger fw-bold">{adsCampaignGroupTitle}</span>
                    <span className="ms-1">/</span> <span className="text-muted">Create (Project)</span>
                </div>
            </div>
            <div className="rounded bg-white p-4 shadow">
                <div className="row">
                    <div className="col-12 col-md-6">
                        <form>
                            <div className="row g-3 border rounded bg-light p-2 mt-0 mb-3">
                                <div className="col-12 mt-1">
                                    <label htmlFor="name" className="form-label">ชื่อ Group Item <span className="text-danger">*</span></label>
                                    <input type="text" className="form-control" id="name" ref={refName} maxLength={100} />
                                </div>
                                <div className="col-12">
                                    <label htmlFor="projectTypeId" className="form-label">Platform</label>
                                    <Select
                                        isClearable={true}
                                        classNamePrefix="form-select-search"
                                        options={platform}
                                        onChange={(event) => onChangePlatformId(event)}
                                        value={platformId}
                                        getOptionValue={(option) => `${option.id}`}
                                        getOptionLabel={(option) => `${option.name}`}
                                    />
                                </div>
                            </div>
                            <div className="row g-3 border rounded bg-light p-2 my-3">
                                <div className="col-12 mt-1">
                                    <label htmlFor="agency" className="form-label">Agency <span className="text-danger">*</span></label>
                                    <Select
                                        isClearable={true}
                                        classNamePrefix="form-select-search"
                                        options={agency}
                                        onChange={(event) => onChangeAgencyId(event)}
                                        value={agencyId}
                                        getOptionValue={(option) => `${option.id}`}
                                        getOptionLabel={(option) => `${option.slug}`}
                                    />
                                </div>
                            </div>

                            <div className="row g-3 border rounded bg-yellow-light p-2 my-3">
                                {
                                    adsNaming.length <= 0 ? (<p>ไม่พบข้อมูล Ads Naming</p>) :
                                        adsNaming.map((row, index) => {
                                            let inputText = "sourceTypeText["+row.id+"]";
                                            let formId = '';
                                            let source = row.source;
                                            let inputType = row.inputType;
                                            let selected = null;

                                            if(inputType === Utils.ADSNAMING_TYPE_SLUG_PROJECT) {
                                                formId = 'slug-project';
                                                return (
                                                    <div key={index}>
                                                        <div className="d-block fw-bold">{row.name}
                                                            <span className="text-muted small d-block fw-light">{'{lang}-{project-type-slug}-{project-slug}'}</span>
                                                        </div>
                                                        <div className=" css-b62m3t-container"><input className="form-control" type="text" id={formId} name={inputText} disabled={true} /></div>
                                                    </div>
                                                );
                                            }
                                            else if(inputType === Utils.ADSNAMING_TYPE_SLUG_PROMOTION) {
                                                // -- empty
                                            }
                                            else if(inputType === Utils.ADSNAMING_TYPE_SLUG_SPECIAL) {
                                                // -- empty
                                            }
                                            else if(inputType === Utils.ADSNAMING_TYPE_FREEFORM) {
                                                formId = 'freeform';
                                                return (
                                                    <div key={index}>
                                                        <div className="d-block fw-bold">{row.name}</div>
                                                        <div className=" css-b62m3t-container"><input className="form-control" type="text" id={formId} name={inputText} onKeyUp={e => {
                                                            if(e && e.target.value) {
                                                                e.target.value = Utils.utmSlug(e.target.value);
                                                            }
                                                        }} /></div>
                                                    </div>
                                                );
                                            }
                                            else if(inputType === Utils.ADSNAMING_TYPE_KOL_PAGE) {
                                                return (
                                                    <div key={index}>
                                                        <div className="d-block fw-bold">{row.name} <span className="text-danger">*</span></div>
                                                        <div className=" css-b62m3t-container">
                                                            <Select
                                                                isClearable={true}
                                                                name="sourceTypeIds[]"
                                                                classNamePrefix="form-select-search"
                                                                options={kolPage.length > 0 ?kolPage.find(e => e.id === row.id).data : null}
                                                                getOptionValue={(option) => `${option.id}`}
                                                                getOptionLabel={(option) => `${option.name}`}
                                                            />
                                                        </div>
                                                    </div>
                                                );
                                            }
                                            else {
                                                if(platformId !== null && row.name !== 'BG' && row.name !== 'AgencyMaster') {
                                                    return (
                                                        <div key={index}>
                                                            <div className="d-block fw-bold">{row.name} <span className="text-danger">*</span></div>
                                                            <Select
                                                                isClearable={true}
                                                                name="sourceTypeIds[]"
                                                                classNamePrefix="form-select-search"
                                                                options={source.filter(o => o.platform.some(e => e.adsPlatformId === platformId.id))}
                                                                getOptionValue={(option) => `${option.id}`}
                                                                getOptionLabel={(option) => `${option.name}`}
                                                            />
                                                        </div>
                                                    );
                                                }
                                                else {
                                                    if(row.name === 'Agency' || row.name === 'AgencyMaster') {
                                                        if(roles.agencyId && agency) {
                                                            let ag = agency.filter(e => e.id === roles.agencyId)[0];
                                                            selected = source.filter(e => e.name === ag.slug);
                                                        }
                                                    }
                                                    return (
                                                        <div key={index}>
                                                            <div className="d-block fw-bold">{row.name} <span className="text-danger">*</span></div>
                                                            <Select
                                                                isClearable={true}
                                                                name="sourceTypeIds[]"
                                                                classNamePrefix="form-select-search"
                                                                options={source}
                                                                defaultValue={selected}
                                                                getOptionValue={(option) => `${option.id}`}
                                                                getOptionLabel={(option) => `${option.name}`}
                                                            />
                                                        </div>
                                                    );
                                                }
                                            }
                                        })
                                }
                            </div>

                            <div className="row g-3 mb-3">
                                <div className="col-12">
                                    <label htmlFor="statusx" className="form-label">สถานะ</label>
                                    <div className="form-check form-switch">
                                        <input className="form-check-input" type="checkbox" name="statusChecked" id="status" defaultChecked={true} />
                                        <label className="form-check-label" htmlFor="status"></label>
                                    </div>
                                </div>
                            </div>

                            <div className="row g-3">
                                <div className="col-12">
                                    <button type="button" className="btn btn-primary" onClick={onCreate}><span
                                        className={isLoading ? 'spinner-grow spinner-grow-sm' : 'd-none'}></span> {isLoading ? btnTextLoading : btnTextDefault}</button>
                                    <NavLink className="btn btn-sm btn-light ms-2" to={backPath}><span><Icon.ArrowLeft/> กลับไป</span></NavLink>
                                    <Toaster position="bottom-right" />
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="col-12 col-md-6"></div>
                </div>
            </div>
        </main>
    );
} 